const roles = [
  { role: 1, description: "quest" },
  { role: 2, description: "admin" },
  { role: 3, description: "user" },
];

const roleArr = {
  notAuth: [1],
  isAuth: [1, 2, 3],
};

/* role pages */
const rolePageArr = {
  HomePage: [1, 2, 3],
  ErrorPage: [1, 2, 3],
  Error404: [1, 2, 3],
  TosPage: [1, 2, 3],
  PrivacyPage: [1, 2, 3],
  CookiePolicyPage: [1, 2, 3],
  ContactPage: [1, 2, 3],
  UsersHome: [1, 2, 3],
  UsersSignIn: [1, 2, 3],
  UsersUpdate: [1, 2, 3],
  UsersDetail: [1, 2, 3],
  UsersList: [1, 2, 3],
  UsersSearch: [1, 2, 3],
  UsersLogin: [1, 2, 3],
  UsersForgotPassword: [1, 2, 3],
  SchemaHome: [1, 2, 3],
  SchemaCreate: [1, 2, 3],
  SchemaUpdate: [1, 2, 3],
  SchemaDetail: [1, 2, 3],
  SchemaList: [1, 2, 3],
  SchemaSearch: [1, 2, 3],
  ContactsHome: [1, 2, 3],
  ContactsCreate: [1, 2, 3], 
  ContactsUpdate: [1, 2, 3], 
  ContactsDetail: [1, 2, 3], 
  ContactsList: [1, 2, 3], 
  ContactsSearch: [1, 2, 3], 
  TasksHome: [1, 2, 3],
  TasksCreate: [1, 2, 3],
  TasksUpdate: [1, 2, 3],
  TasksDetail: [1, 2, 3],
  TasksList: [1, 2, 3],
  TasksSearch: [1, 2, 3],
  KanbanBoard: [1, 2, 3],
  CalendarView: [1, 2, 3],
  MermaidHome: [1, 2, 3],
  MermaidCreate: [1, 2, 3],
  MermaidUpdate: [1, 2, 3],
  MermaidDetail: [1, 2, 3],
  MermaidList: [1, 2, 3],
  MermaidSearch: [1, 2, 3],
  // Admin pages
  AdminHome: [1, 2, 3],
  AdminSettings: [1, 2, 3],
  AdminSiteSettings: [1, 2, 3],
  AdminUsers: [1, 2, 3],
  AdminAnalytics: [1, 2, 3],
  AdminLogs: [1, 2, 3],
  AdminSchema: [1, 2, 3],
  AdminSchemaCreate: [1, 2, 3],
  AdminSchemaUpdate: [1, 2, 3],
  AdminSchemaDetail: [1, 2, 3],
  AdminContacts: [1, 2, 3],
  DockerInfo: [3],
  SettingsHome: [2, 3],
  SettingsCreate: [1, 2, 3], 
  SettingsUpdate: [2, 3], 
  SettingsDetail: [2, 3], 
  SettingsList: [2, 3], 
  SettingsSearch: [2, 3], 
  QuestionsHome: [2, 3],
  QuestionsCreate: [1, 2, 3], 
  QuestionsUpdate: [2, 3], 
  QuestionsDetail: [2, 3], 
  QuestionsList: [2, 3], 
  QuestionsPages: [2, 3], 
  QuestionsPagesId: [2, 3],
  QuestionsPagesPreview: [2, 3], 
  BooksHome: [2, 3],
  BooksCreate: [1, 2, 3], 
  BooksUpdate: [2, 3], 
  BooksDetail: [2, 3], 
  BooksList: [2, 3], 
  BooksSearch: [2, 3], 
  BooksPreview: [2, 3],
  ActivitybooksHome: [2, 3],
  ActivitybooksCreate: [2, 3],
  ActivitybooksUpdate: [2, 3],
  ActivitybooksDetail: [2, 3],
  ActivitybooksList: [2, 3],
  ActivitybooksSearch: [2, 3],
  ActivitybooksPreview: [2, 3],
  ImagesHome: [2, 3],
  ImagesCreate: [1, 2, 3], 
  ImagesUpdate: [2, 3], 
  ImagesDetail: [2, 3], 
  ImagesList: [2, 3], 
  ImagesSearch: [2, 3], 
  DemoHome: [2, 3],
  DemoCreate: [1, 2, 3], 
  DemoUpdate: [2, 3], 
  DemoDetail: [2, 3], 
  DemoList: [2, 3], 
  DemoSearch: [2, 3], 
  empty: [],
};

export default { ...roleArr, ...rolePageArr };
export { roles };
